import {PlayerProfile} from './player-profile';
import {environment} from '../../../../environments/environment';

export class PlayerPictureReport
{
  id: number;
  reportDate: Date;

  reportText: string;
  reportName: string;
  reportMail: string;
  reportPictureFilename: string;
  pictureUrl: string;

  statusCd: string;
  verificationText: string;

  responseSent: boolean;

  playerProfile: PlayerProfile;

  count?: number;

  public static init(item: PlayerPictureReport): void
  {
    if (item.reportDate)
      item.reportDate = new Date(item.reportDate);

    item.responseSent = !!item.responseSent;

    if (!item.pictureUrl && item.reportPictureFilename)
      item.pictureUrl = environment.baseUrlPlayerProfile + 'profile-images/' + item.reportPictureFilename;
  }
}
